import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom'
import '../../Styles/Competitions.css'

function Competitions() {
    
    return (
      <div className='mainbody'>
        <p className='headline_comp bold'>Games</p>
  
        <div className='row outer_frame  frame_gap'>
        <Link to={`/higherlower`} style={{ textAlign: 'center' }}><button>Higher/Lower</button></Link>        
        </div>
  
      </div>          
    );
          
}

export default Competitions;